import { Instagram, Mail } from 'lucide-react';
import { BRAND, SOCIAL } from '../constants/brand';

export const Footer = () => {
  return (
    <footer 
      className="py-10 md:py-12 bg-aya-black border-t border-aya-border"
      data-testid="footer"
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Top Row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
            {/* Brand */}
            <div className="text-center md:text-left">
              <h3 className="font-heading font-black text-2xl text-aya-yellow mb-1">
                {BRAND.name}
              </h3>
              <p className="text-zinc-500 text-sm">
                {BRAND.fullName}
              </p>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-6">
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  flex items-center gap-2 text-white/60 
                  hover:text-aya-yellow transition-colors duration-200
                "
                data-testid="footer-instagram"
                aria-label="Follow AYA on Instagram"
              >
                <Instagram className="w-5 h-5" />
                <span className="text-sm hidden sm:inline">Instagram</span>
              </a>

              <a
                href={`mailto:${SOCIAL.email}`}
                className="
                  flex items-center gap-2 text-white/60 
                  hover:text-aya-yellow transition-colors duration-200
                "
                data-testid="footer-email"
                aria-label="Email AYA"
              >
                <Mail className="w-5 h-5" />
                <span className="text-sm hidden sm:inline">Email</span>
              </a>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-aya-border my-8" />

          {/* Bottom Row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Tagline */}
            <p className="font-mono text-zinc-600 text-sm">
              AYA — A. Y. A.
            </p>

          </div>

          {/* Copyright */}
          <p className="text-center text-zinc-700 text-xs mt-8">
            © {new Date().getFullYear()} AYA Arts & Entertainment Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
